import React from 'react'

import { DataCard, Details, Title, Message } from '../data-card/data-card-parts'
import UnsatisfactoryAreasButton from './unsatisfactory-areas-button'

export default ({
  location,
  technicianWorkSummaries = [],
  finishedLoading,
  goToServicingVersions,
  contractId
}) => {
  let summaries
  if (technicianWorkSummaries.length > 0) {
    summaries = (
      technicianWorkSummaries.map(({id, technicianId, technicianName, averageCompleted = 0, countUnsatisfactory = 0}) =>
        <div key={id} className='technician-work-summary card' style={{display: 'flex'}}>
          <p className='technician-name' style={{flex: '3'}}><strong>{technicianName}</strong></p>
          <p style={{flex: '1'}}><UnsatisfactoryAreasButton style={{display: 'flex', justifyContent: 'space-between'}} onClick={() => {goToServicingVersions(contractId, technicianId)}} ><span>Corrective Action</span><span style={{textAlign: 'right'}}>({countUnsatisfactory})</span></UnsatisfactoryAreasButton></p>
          <p style={{flex: '2', textAlign: 'right'}}>({averageCompleted && averageCompleted.toFixed(2) || 0}) Daily Average</p>
        </div>
      )
    )
  } else {
    summaries = (
      <div className='technician-work-summary card'>
        <p className='technician-name'>{finishedLoading ? 'No Technicians have completed any services' : 'Loading...' }</p>
      </div>
    )
  }

  return (
    <div>
      <div className='technician-work-summary card'>
        <p className='technician-name'><strong>Benchmark Goal</strong></p>
        <p>({location.averageDailyServicesTarget}) Daily Average</p>
      </div>

      <div className='technician-work-summary card'>
        <p className='technician-name'><strong>Property Average</strong></p>
        <p>({location.propertyAverage && location.propertyAverage.toFixed(2) || 0 }) Daily Average</p>
      </div>

      {summaries}
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/technician-work-summaries/technician-work-summary-details.js